var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "switch-control",
      class: { "switch-checked": _vm.value },
      attrs: { "data-test-value": _vm.value ? "true" : "false" },
      on: {
        click: function ($event) {
          return _vm.onChange(!_vm.value)
        },
      },
    },
    [_c("div", { staticClass: "switch-handle" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }